import FrontText from "../../FrontText";
import { useForm, usePage } from "@inertiajs/react";
import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import FrontContactInputLabel from "../../Forms/Contact/FrontContactInputLabel";
import FrontContactTextInput from "../../Forms/Contact/FrontContactTextInput";
import FrontContactTextarea from "../../Forms/Contact/FrontContactTextarea";
import FrontContactAcceptance from "../../Forms/Contact/FrontContactAcceptance";

const WarehouseContactForm = ({ referer }) => {
    const { t, i18n } = useTranslation();
    const { success, error } = usePage().props?.flash ?? {};

    const submitRoute = i18n.resolvedLanguage === 'pl'
        ? 'send-contact-form'
        : 'send-contact-form.en';
    
    const { data, setData, post, reset, wasSuccessful, errors } = useForm({
        name_surname: "",
        email: "",
        phone: "",
        message: "",
        acceptance_personal_data: false,
        marketing_acceptance: false,
        referer: referer,
        recaptcha_token: "",
    });

    const submit = async (e) => {
        e.preventDefault();

        const token = await grecaptcha.execute(import.meta.env.VITE_RECAPTCHA_SITE_KEY, { action: 'submit' });
        setData("recaptcha_token", token);
    };

    useEffect(() => {
        if(data.recaptcha_token){
            post(route(submitRoute), {
                preserveScroll: true,
                onSuccess: () => {
                    reset();
                },
            });
        }
    }, [data.recaptcha_token])

    const transLink = {
        1: <a title={t('footer.privacy_policy')} target="_blank" href={`/storage/savills_polityka_prywatnosci.pdf`} className="text-dark-blue underline">{t('footer.privacy_policy')}</a>
    }

    return (
        <div className="w-full bg-white border border-light-blue">
            <form
                onSubmit={submit}
                className="p-5"
            >
                <div className="w-full">
                    <FrontContactInputLabel
                        htmlFor="name_surname"
                        value={t("contact_page.name_surname_label")}
                    />

                    <FrontContactTextInput
                        id="name_surname"
                        type="text"
                        name="name_surname"
                        value={data.name_surname}
                        className="w-full"
                        onChange={(e) => setData("name_surname", e.target.value)}
                        required
                    />

                    <FrontContactInputLabel
                        htmlFor="email"
                        value={t("contact_page.email_label")}
                    />

                    <FrontContactTextInput
                        id="email"
                        type="email"
                        name="email"
                        value={data.email}
                        className="w-full"
                        onChange={(e) => setData("email", e.target.value)}
                        required
                    />

                    <FrontContactInputLabel
                        htmlFor="phone"
                        value={t("contact_page.tel_label")}
                    />

                    <FrontContactTextInput
                        id="phone"
                        type="tel"
                        name="phone"
                        value={data.phone}
                        className="w-full"
                        onChange={(e) => setData("phone", e.target.value)}
                        required
                    />

                    <FrontText textSize={`12/15`} className="text-new-blue my-3">
                        <p>
                            {t('popup.acceptance1')}
                        </p>
                    </FrontText>
                    <FrontText textSize={`12/15`} className="text-new-blue mb-3">
                        <p>
                            <Trans i18nKey={'popup.acceptance2'} components={transLink} />
                        </p>
                    </FrontText>

                    <FrontContactAcceptance
                        id="acceptance_personal_data"
                        name="acceptance_personal_data"
                        className="mt-2"
                        checked={data.acceptance_personal_data}
                        required
                        onChange={(e) =>
                            setData(
                                "acceptance_personal_data",
                                e.target.checked ? true : false
                            )
                        }
                    >
                        <p>{t("contact_page.acceptance_personal_data")}</p>
                    </FrontContactAcceptance>

                    <FrontContactAcceptance
                        id="marketing_acceptance"
                        name="marketing_acceptance"
                        className="mt-5"
                        checked={data.marketing_acceptance}
                        onChange={(e) =>
                            setData(
                                "marketing_acceptance",
                                e.target.checked ? true : false
                            )
                        }
                    >
                        <p>{t("contact_page.acceptance_newsletter")}</p>
                    </FrontContactAcceptance>
                </div>

                <div className="w-full mt-7">
                    <FrontContactInputLabel
                        htmlFor="message"
                        value={t("contact_page.message_label")}
                    />
                    <FrontContactTextarea
                        name="message"
                        id="message"
                        required
                        className="min-h-[230px] max-h-80"
                        value={data.message}
                        onChange={(e) => setData("message", e.target.value)}
                    />

                    <button
                        type="submit"
                        className="bg-light-blue h-10 max-w-[350px] w-full mb-5 rounded-lg mx-auto block border-2 border-light-blue text-white hover:bg-white hover:text-light-blue transition-all ease-in-out duration-300"
                    >
                        <FrontText
                            textSize="14/17"
                            className="uppercase font-semibold"
                        >
                            {t("contact_page.send")}
                        </FrontText>
                    </button>

                    {(wasSuccessful && !error) && <p className="text-dark-blue-standard text-12 font-bold mt-4">{success}</p>}
                    {error && <p className="text-danger text-12 font-bold mt-4">{error}</p>}
                    {Object.keys(errors).length > 0 &&
                        <div className="mt-6">
                            {Object.values(errors).map((er, i) => (
                                <p className="text-12 text-danger font-bold mb-4" key={i}>{er}</p>
                            ))}
                        </div>
                    }
                </div>
            </form>
        </div>
    );
};

export default WarehouseContactForm;
